/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import _ from "underscore";
import birdata from "../../../api.js";
import ko from "knockout";

import shapefileHelper from "./shapefile.js";

function RegionImporter(params) {
	var self = this;

	// TODO:
	// self.importSpecificationURL = "http://birdata.birdlife.org.au/survey-import-data-specification";

	self.selectFileOptions = shapefileHelper.selectFileOptions;

	self.ready = ko.observable(true);

	self.idField = ko.observable('ID');
	self.nameField = ko.observable('Name');

	self.showFileSelect = ko.observable(true);

	self.updateMeta = function(meta) {

		meta.id_field = self.idField();
		meta.name_field = self.nameField();
	};

	self.loadMeta = function(json) {
		var meta = json.meta;

		self.idField(meta.id_field);
		self.nameField(meta.name_field);

		return Promise.resolve(true);
	};

	self.checkFiles = shapefileHelper.checkFiles;
}

export default RegionImporter;
